import {
  ThankYouBackground, ThankYouContainer, ThankYouCloseIcon, ThankYouTextContainer, ThankYouHeader, ThankYouSubtitle,
  ThankYouImg, ThankYouSuccessText, ThankYouSuccessPlan, ThankYouButtonContainer, ThankYouButtonText
} from "views/PaymentFlow/ThankYou/ThankYou.styles";
import Images from "config/Images";
import {useAppSelector} from "store/hooks";
import {useDispatch} from "react-redux";
import {updateShowThankYou, updateShowThankYouScreen} from "store/ui/thankYouScreen/thankYouScreen.slice";

function ThankYou() {
  const dispatch = useDispatch();
  const plan = useAppSelector(state => state.subscriptionPlan);

  const buttonStyles = {
    display: 'flex',
    marginTop: '10px',
    width: '30%',
    justifyContent: 'center'
  }

  return (
    <>
      <ThankYouBackground/>

      <ThankYouContainer>
        <ThankYouCloseIcon className={'fa-solid fa-xmark'} onClick={() => dispatch(updateShowThankYouScreen(false))}/>
        <ThankYouTextContainer>
          <ThankYouHeader> Thank You! </ThankYouHeader>
          <ThankYouSubtitle> for your purchase </ThankYouSubtitle>
          <ThankYouImg src={Images.paymentsThankYou}/>
          <ThankYouSuccessText>You have successfully subscribed to</ThankYouSuccessText>
          <ThankYouSuccessPlan>Benev {plan.organizationType + " " + plan.name}!</ThankYouSuccessPlan>
          <ThankYouButtonContainer>
            <ThankYouButtonText> Start celebrating wins! </ThankYouButtonText>
          </ThankYouButtonContainer>
        </ThankYouTextContainer>
      </ThankYouContainer>
    </>
  )
}

export default ThankYou;
